/* eslint-disable global-require, import/no-unresolved */
module.exports = require('./build/index.cjs');
